const FoodDeliveryKey = ({ data, showIndex, handleShow }) => {
  return (
    <div className="fd-key-acc-wrap">
      {/* title */}
      <div
        className={`fd-acc-tl ${showIndex ? "bb" : ""} `}
        onClick={handleShow}
      >
        <div className="fd-acc-tl-left">
          <div className="fd-acc-top-img">
            <img src={data.img} alt="Food delivery app development company" />
          </div>
          <h4 className="fd-acc-title">{data.title}</h4>
        </div>

        <div className="fd-acc-tl-right">
          {!showIndex ? (
            <i className="fa-solid fa-arrow-right acc-up"></i>
          ) : (
            <i className="fa-solid fa-arrow-down acc-down"></i>
          )}
        </div>
      </div>

      {/* content */}
      <div className={`fd-acc-content ${showIndex ? "show" : ""}`}>
        <ul className="fd-acc-content-list">
          {data.content.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FoodDeliveryKey;
